import { render } from "./Vertreter.vue?vue&type=template&id=0dc88a8e&scoped=true"
import script from "./Vertreter.vue?vue&type=script&lang=js"
export * from "./Vertreter.vue?vue&type=script&lang=js"

import "./Vertreter.vue?vue&type=style&index=0&id=0dc88a8e&lang=stylus&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc88a8e"]])

export default __exports__